<script>
  import Page from '@components/page'
  import Text from '@components/general/text.svelte'
  import Block from '@components/general/block';
  import LiveSessionCard from '@components/live_sessions/card.svelte'
  import ResourceCard from '@components/resources/card.svelte'
  import VideoCard from '@components/videos/card.svelte'
  import { page } from '@inertiajs/svelte'
  import WelcomeBlock from '@components/general/welcome-block.svelte'
  import Message from '@components/general/message.svelte'
  import { House, FileDown, Video, CirclePlay, ChevronRight, Sun, User, BrickWallShield } from 'lucide-svelte'
  import { onMount } from 'svelte'

  // let { upcomingSessions, subscription } = dashboardData
  let { latest_video, latest_resource, upcoming_sessions = [] } = $props()
  
  let title = "Altruist Wellbeing Forum"

  let user = $derived($page.props.user)
  let membership = $derived($page.props.user?.current_membership)
  let pendingMembership = $derived(membership?.status === 'inactive')
  let checkoutSuccess = $state(false)

  onMount(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('checkout') === 'success') {
      checkoutSuccess = true
      window.history.replaceState({}, '', window.location.pathname)
    }
  })

  let welcomeActions = $derived([
    ...(user?.is_admin ? [{ label: "Admin", path: "/admin", Icon: BrickWallShield }] : []),
    { label: "Videos", path: "/videos", Icon: CirclePlay },
    { label: "Resources", path: "/resources", Icon: FileDown },
    { label: "Live Sessions", path: "/live-sessions", Icon: Video },
    { label: "Profile", path: "/settings/profile", Icon: User },
  ])

</script>

<svelte:head>
  <title>Altruist Wellbeing Forum</title>
</svelte:head>

<Page.Layout {title}>

  <Page.Navigation includeHome={false} title="Dashboard" Icon={House} />

  <Page.Content>
    {#snippet children()}

      <!-- Main content -->
      <div class="flex flex-col gap-6">
        
        <!-- Checkout / membership status message -->
        {#if checkoutSuccess && !pendingMembership}
          <Message type="success" title="Payment successful" message="Your membership is now active. Enjoy!" />
        {:else if checkoutSuccess && pendingMembership}
          <Message type="success" title="Payment successful" message="Your membership is being processed and will be activated shortly." />
        {/if}

        <!-- Welcome block -->
        <WelcomeBlock title={`Welcome back, ${user.first_name}!`} Icon={Sun} color="yellow" actions={welcomeActions} />

        <!-- Main content area -->
        <div class="page-content">
          
          <!-- The main content area -->
          <main>
            
            <!-- Featured video -->
            <div>
              <Text variant="title" as="h2" text="Latest video" class="text-xl sm:text-2xl mb-4" />
              {#if latest_video}
                <VideoCard video={latest_video} label="Video" />
              {:else}
                <p>No videos available</p>
              {/if}
            </div>

            <!-- Upcoming sessions -->
            {#if upcoming_sessions.length > 0}
              <div>
                <Text variant="title" as="h2" text="Upcoming sessions" class="text-xl sm:text-2xl mb-4" />
                <div class="grid gap-6 grid-cols-1 md:grid-cols-2">
                  {#each upcoming_sessions as session (session.id)}
                    <LiveSessionCard {session} label="Upcoming session" />
                  {/each}
                </div>
              </div>
            {/if}

          </main>

          <!-- The aside content area -->
          <aside>
            
            <!-- Latest resource - top of aside -->
            <div>
              <Text variant="title" as="h2" text="Latest resource" class="text-xl sm:text-2xl mb-4" />
              {#if latest_resource}
                <ResourceCard resource={latest_resource} label="Resource" />
              {:else}
                <p>No resources available</p>
              {/if}
            </div>

            <!-- Quick links -->
              <Block.Element title="Quick links">
                <Block.Items>
                  <Block.Link text="View profile" path="/settings/profile" Icon={User} />
                  <Block.Link text="Browse videos" path="/videos" Icon={Video} />
                  <Block.Link text="View resources" path="/resources" Icon={FileDown} />
                  <Block.Link text="Live sessions" path="/live-sessions" Icon={CirclePlay} />
                </Block.Items>
              </Block.Element>
          </aside>

        </div>

      </div>

    {/snippet}
  </Page.Content>

</Page.Layout>
